import { useCallback } from 'react';

import { useSubscribe } from './useSubscribe.ts';
import { useUnsubscribe } from './useUnsubscribe.ts';

export const useToggleSubscription = (
  subscription: { slug: string } | null | undefined,
  subscribable: { __typename: string; slug: string },
  onToggled?: () => void,
  refetchQueries?: string[]
) => {
  const unsubscribe = useUnsubscribe(refetchQueries);
  const subscribe = useSubscribe(refetchQueries);

  const toggleSubscription = useCallback(async () => {
    if (subscription) {
      await unsubscribe(subscription);
    } else {
      await subscribe(subscribable);
    }
    onToggled?.();
  }, [subscription, onToggled, unsubscribe, subscribe, subscribable]);

  return toggleSubscription;
};
